import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

export interface Props {
  onClick: () => void
  label: string
  disabled: boolean
}

const ConfirmButton = ({ onClick, label, disabled }: Props) => {
  return (
    <Button disabled={disabled} onClick={onClick} type="primary">
      {label}
    </Button>
  )
}

export default ConfirmButton
